// import api here to intersept auth errors
import {AuthPayload} from "../common/auth";
import AuthRepository, {IAuthRepository} from "../repositories/auth";


export class AuthService {
    private repository: IAuthRepository;
    constructor(repositoryInstance: IAuthRepository) {
        this.repository = repositoryInstance;
    }

    login(username: AuthPayload['username'], password: AuthPayload['password']) {
        return this.repository.login(username, password);
    }

    register(params: AuthPayload) {
        return this.repository.register(params);
    }
    logout() {
        this.repository.logout();
    }
};

const authService = new AuthService(new AuthRepository());

export default authService;